import { Link } from 'react-router-dom'
import './EnquiryResponseChecklist.css'

const EnquiryResponseChecklist = () => {
  return (
    <div className="enquiry-checklist-page">
      <div className="page-header">
        <div>
          <h2>📋 Call Enquiry Response Checklist</h2>
          <p className="subtitle">Product: AI Sec Training Products</p>
        </div>
      </div>

      <div className="checklist-container">
        {/* Before the Call */}
        <section className="checklist-section">
          <h3>📅 Before the Call</h3>
          
          <div className="checklist-category">
            <h4>1. Review the Booking Details</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Confirm the time, date, and timezone</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Note the caller's name, organization, and role</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Check which training product or topic they selected in Calendly</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Review any notes or questions they included in the booking form</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>2. Research the Lead</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Look up their company (LinkedIn or website) for industry, size, and potential training needs</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Identify whether they are likely an individual learner, team manager, or organizational decision-maker</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>3. Prepare Resources</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Keep product summaries, course outlines, and pricing tiers open — review <Link to="/pricing-playbook">Pricing Playbook</Link> and <Link to="/price-list">Price List</Link></span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Have a link ready to your product landing page or brochure</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Know your key differentiators (e.g., certification, practical labs, industry alignment)</span>
            </label>
          </div>
        </section>

        {/* During the Call */}
        <section className="checklist-section">
          <h3>📞 During the Call</h3>
          
          <div className="checklist-category">
            <h4>1. Warm Introduction</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Greet them by name and thank them for scheduling the call</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Confirm how much time they have</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Briefly introduce yourself and your role (e.g., "I help clients identify the right training solution for their team.")</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>2. Understand Their Needs</h4>
            <p className="checklist-note">Ask discovery questions such as:</p>
            <ul className="checklist-bullets">
              <li>"What prompted your interest in this training?"</li>
              <li>"Who will be attending — individual learners or your team?"</li>
              <li>"Do you have a target certification or skill outcome in mind?"</li>
            </ul>
            <p className="checklist-note">Take notes on:</p>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Pain points or goals</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Number of learners</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Urgency (e.g., start date)</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Budget or approval process</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>3. Present the Right Product</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Match their needs to one of your training offerings</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Briefly describe course structure (modules, duration, format)</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Briefly describe outcomes or certifications</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Briefly describe support or assessment options</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Highlight relevant success stories or client examples</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>4. Address Common Questions</h4>
            <p className="checklist-note">Be ready to answer:</p>
            <ul className="checklist-bullets">
              <li>"How long does the course take?"</li>
              <li>"Is it suitable for beginners?"</li>
              <li>"What's included in the price?"</li>
              <li>"Do you offer group or enterprise discounts?"</li>
              <li>"Can I get a demo or sample lesson?"</li>
            </ul>
          </div>

          <div className="checklist-category">
            <h4>5. Next Steps / Call to Action</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Offer a clear next step based on interest (send proposal, schedule demo, enroll directly)</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Confirm their preferred communication channel (email, WhatsApp, LinkedIn, etc.)</span>
            </label>
          </div>
        </section>

        {/* After the Call */}
        <section className="checklist-section">
          <h3>✅ After the Call</h3>
          
          <div className="checklist-category">
            <h4>1. Log the Call</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Record summary notes (interests, objections, next steps) in your CRM — <Link to="/contacts">Contacts</Link> or <Link to="/deals">Deals</Link> page</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Mark the call outcome (e.g., "Interested – Proposal Sent")</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>2. Follow Up Within 24 Hours</h4>
            <p className="checklist-note">Send a personalized email that includes:</p>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>A short thank you</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>The discussed product summary or brochure</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Any additional requested information</span>
            </label>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>A clear next action (e.g., "Let's finalize your training plan this week")</span>
            </label>
          </div>

          <div className="checklist-category">
            <h4>3. Set a Reminder</h4>
            <label className="checklist-item">
              <input type="checkbox" />
              <span>Schedule a follow-up reminder for 3–5 days later if they haven't responded</span>
            </label>
          </div>
        </section>

        {/* Optional Add-ons */}
        <section className="checklist-section">
          <h3>🔧 Optional Add-ons</h3>
          <p className="checklist-note">If your team takes multiple enquiries per week:</p>
          <ul className="checklist-bullets">
            <li>Use a response template for common call summaries</li>
            <li>Create a FAQ sheet with short, approved answers</li>
            <li>Maintain a "product matching guide" — e.g.,
              <ul className="checklist-bullets nested">
                <li>Compliance Awareness → Best for non-technical staff</li>
                <li>Secure Coding → Best for developers</li>
                <li>Incident Response → Best for IT/SOC teams</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Other Points */}
        <section className="checklist-section important-notes">
          <h3>📌 Other Points</h3>
          <div className="important-note">
            <p><strong>Refer to "our team"</strong> and not any one individual</p>
          </div>
          <div className="important-note">
            <p><strong>Mention our team is located in:</strong> US, Dubai, Malaysia and Singapore</p>
          </div>
          <div className="important-note">
            <p><strong>All live prices are on:</strong></p>
            <ul className="checklist-bullets">
              <li>The certification page: <a href="https://aisectraining.com/aisec-ai-security-certifications" target="_blank" rel="noopener noreferrer">https://aisectraining.com/aisec-ai-security-certifications</a></li>
              <li>The CRM <Link to="/pricing-playbook">Pricing Playbook</Link> and <Link to="/price-list">Price List</Link> pages for all courses and certifications</li>
            </ul>
          </div>
          <div className="important-note">
            <p><strong>Course releases are due:</strong> Nov through to Feb 2026</p>
          </div>
          <div className="important-note">
            <p><strong>The release schedule has not been released yet</strong> by the development team</p>
          </div>
          <div className="important-note">
            <p><strong>Any question you cannot answer,</strong> we can always follow up</p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default EnquiryResponseChecklist
